<template>
    <div>
        <div v-show="isLink">
            <div class="result">
                <div class="padded info">
                    <div class="item">
                        <p class="fl">运单号码：{{result.waybillNo}}</p>
                    </div>
                    <p>登记日期：{{result.regTime?dateFormat(result.regTime):''}}</p>
                    <p>问题类型：{{result.problemType}}</p>
                    <p>当前状态：{{result.status}}</p>
                    <p>问题描述：</p>
                    <p class="desc">
                        {{result.problemDesc}}
                    </p>
                </div>
            </div>
            <div v-show="result.status !== '处理完毕' && result.status !== '无需回复' && disableFunc.indexOf('1_1') === -1">
                <div class="replay">
                    <p class="padded" style="color: #666;margin-bottom: 4px;">问题件回复</p>
                    <div style="background: #fff;padding: 10px 15px;">
                        <img src="../../assets/edit.png" alt="" width="14" style="display: inline-block;margin-top:6px;"
                             v-if="!content">
                        <textarea v-model="content"
                                  style="font-size: 14px;width: calc(100% - 24px);display: inline-block;vertical-align: top;border:none;height:200px;"
                                  placeholder="请输入您的回复消息..."></textarea>
                    </div>
                </div>
                <div class="mt-gap2">
                    <mt-button type="primary" style="width: 100%;border-radius: 0;" @click="replay()">回复</mt-button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                result: {waybillNo: '', problemDesc: ''},
                content: '',
                serverIds: [],
                localIds: [],
                localImgData: [],
                isLink: false,
                companyNo: '',
                disableFunc: []
            }
        },
        created() {
            this.companyNo = this.$util.get('companyNo');
            if (this.$route.query.id) {
                this.getDetail(this.$route.query.id)
            }
        },
        methods: {
            dateFormat(time) {
                let date = new Date(time);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0' + day;
                }
                return year + '-' + month + '-' + day;
            },
            getDetail(id) {
                this.http.send({
                    command: 'orderProblem/findOrderProblemDetails',
                    params: {
                        problemId: id
                    }
                }).then(res => {
                    if (res.data.result_code === 0) {
                        this.isLink = true;
                        this.result = res.data.body;
                        return;
                    }
                    if (res.data.result_code !== 1006 && res.data.result_code !== 1009) {
                        this.isLink = true;
                    } else {
                        this.$router.replace({
                            name: 'ProblemResult',
                            query: {type: 1, fromList: this.$route.query.fromList}
                        })
                    }
                }).catch(err => {
                    if (err.data.result_code !== 1006 && err.data.result_code !== 1009) {
                        this.isLink = true;
                    } else {
                        this.$router.replace({
                            name: 'ProblemResult',
                            query: {type: 1, fromList: this.$route.query.fromList}
                        })
                    }
                })
            },
            remove(imgUrl) {
                for (let i = 0; i < this.localImgData.length; i++) {
                    if (this.localImgData[i].imgUrl === imgUrl) {
                        this.localImgData.splice(i, 1);
                        break;
                    }
                }
            },
            replay() {
                if (!this.result.problemId) {
                    this.$toast("数据未同步完全，暂不支持回复");
                    return;
                }
                const attach = this.localImgData.map(item => {
                    return item.imgUrl
                });
                let attachment = attach.join(',');
                if (!this.content) {
                    this.$toast("请填写回复消息");
                    return;
                }
                const param = {
                    content: this.content,
                    attachment: attachment,
                    stano: this.result.stano,
                    problemId: this.result.problemId
                };
                this.http.send({
                    command: 'orderProblem/pushProblemComm',
                    params: param
                }).then(res => {
                    if (res.data.result_code === 0) {
                        this.localImgData = [];
                        this.content = '';
                        this.$router.replace({
                            name: 'ProblemResult',
                            query: {type: 2, fromList: this.$route.query.fromList}
                        })
                    }
                }).catch(err => {
                    alert(JSON.stringify(err))
                })
            }
        }
    }
</script>
<style>
    .replay .mint-cell-wrapper {
        background: none;
    }
</style>
<style lang="less" scoped>
    .result {
        .info {
            background: #fff;
            padding-bottom: 10px;
            .item {
                line-height: 32px;
                border-bottom: 1px solid #f4f3f3;
                padding-bottom: 5px;
                padding-top: 5px;
                margin-bottom: 5px;
                overflow: hidden;

                span {
                    color: #19a0ff;
                }
            }
            p {
                line-height: 30px;
                &.desc {
                    color: #666666;
                    font-size: 14px;
                    line-height: 24px;
                }
            }
        }
    }
    .replay {
        margin-top: 10px;
        .upload-img {
            padding: 5px 5px;
            max-height: 128px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            text-align: center;
            width: 40%;
            margin: 6px auto 4px auto;
            span {
                position: absolute;
                display: inline-block;
                width: 16px;
                height: 16px;
                background: red;
                color: #fff;
                right: 0;
                top: 0;
                border-radius: 50%;
                text-align: center;
                line-height: 16px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/problem/problem-desc.vue